
import { Button, Card, IconButton } from "@/shared/ui";
import { defineComponent } from "vue";
import { useAutoHeight } from "@/shared/composables/useAutoHeight";

//TODO: Add MD editor
export default defineComponent({
	name: "TextField",
	components: {
		IconButton,
		Card,
		Button,
	},
	emits: ["update:modelValue"],
	props: {
		title: {
			type: String,
			default: "",
		},
		modelValue: {
			type: String,
			required: true,
		},
	},
	setup() {
		return useAutoHeight();
	},
	data() {
		return {
			editMode: false,
			tmpValue: "",
		};
	},
	watch: {
		editMode() {
			this.tmpValue = this.modelValue;
		},
	},
	mounted() {
		this.autoUpdateHeight(this.$refs.textarea as HTMLTextAreaElement);
	},
	methods: {
		save() {
			this.$emit("update:modelValue", this.tmpValue);
			this.editMode = false;
		},
	},
});
